import type { IntlShape } from '@atlassian/jira-intl';

import messages from './messages';

export const validate =
	(formatMessage: IntlShape['formatMessage']) =>
	(currentValue: string): string | undefined => {
		if (currentValue === '') {
			return undefined;
		}
		if (
			!currentValue ||
			(!currentValue.startsWith('http:') && !currentValue.startsWith('https:'))
		) {
			return formatMessage(messages.invalidUrl);
		}

		return undefined;
	};
